import { DurationDisplay } from "~/screens/Scheduling/InitialVisit/components/DurationDisplay";
import { VISIT_TYPES, VisitType } from "~/services";
import { useIsPatientRole } from "~/stores";
import { icons } from "~/ui";

type VisitDetailsProps = {
  visitType: VisitType;
};

export const VisitDetails = ({ visitType }: VisitDetailsProps) => {
  const isPatient = useIsPatientRole();
  const isInitialPatientVisit = visitType === VISIT_TYPES.INITIAL && isPatient;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <DurationDisplay
          visitType={visitType}
          icon={
            !isInitialPatientVisit ? (
              <div className="bg-indigo/10 flex size-6 items-center justify-center rounded-full">
                <icons.outline.ClockIcon className="text-indigo size-4" />
              </div>
            ) : undefined
          }
        />
      </div>

      {!isInitialPatientVisit && (
        <div className="flex items-center gap-2">
          <div className="bg-indigo/10 flex size-6 items-center justify-center rounded-full">
            <icons.outline.VideoCameraIcon className="text-indigo h-4 w-4" />
          </div>
          <span className="text-gray-700">Telemedicine visit</span>
        </div>
      )}
    </div>
  );
};
